import React from 'react';
import { SearchItem } from '../../Types/SearchItem';
import clsx from 'clsx';
import { translate } from '../../Services/translation';
import StockStatus from '../StockStatus/StockStatus';
import { ProductStocks } from '../NavisionStock/types/ProductStocks';
import { formatIncomingStocksString } from '../NavisionStock/services/NavisionStockService';

const ProductCardQuickSearch = ({
  product,
  showBothPrices,
  navisionPrice,
  navisionStock,
}: {
  product: SearchItem;
  showBothPrices: boolean;
  navisionPrice?: ProductPriceResponseItem;
  navisionStock?: ProductStocks;
}) => {
  return (
    <a
      href={product.url}
      className={clsx(
        'flex',
        'p-3',
        'border',
        'border-solid',
        'border-gray-100',
        'rounded',
        'gap-3'
      )}
    >
      {product.hasImage && (
        <img
          className={clsx(
            'aspect-square',
            'object-cover',
            'w-[72px]',
            'h-[72px]'
          )}
          src={product.imageSource}
          alt={product.name}
        />
      )}
      <div
        className={clsx('flex', 'flex-col', 'justify-center', 'gap-0.5')}
      >
        <span className="text-md font-bold text-gray-600">
          {product.brand}
        </span>
        <span className="text-md font-bold">{product.name}</span>
        <span className="text-md text-gray-600">
          {translate('product.articleno')} {product.id}
        </span>
        {showBothPrices ? (
          <>
            <h4>
              {navisionPrice?.formattedPrice ??
                translate('product.placeholder.fetching.price')}
            </h4>
            <p className={clsx('text-sm', 'text-gray-500')}>
              {translate('product.recommended-price')}
              {': '}
              {product.price?.formattedPrice}
            </p>
          </>
        ) : product.price.formattedCampaignPrice ? (
          <h4 className="text-error-500">
            {product.price.formattedCampaignPrice}{' '}
            <span className="text-md font-normal text-gray-600 line-through">
              {product.price.formattedPrice}
            </span>
          </h4>
        ) : (
          product.price.formattedPrice && (
            <h4>{product.price.formattedPrice}</h4>
          )
        )}
        {product.productFee &&
          product.productFee.length > 0 &&
          product.productFee.map((fee) => (
            <p
              className={clsx('text-sm', 'text-gray-500')}
              key={fee.feeTypeName}
            >
              {translate('product.fee')} ({fee.feeTypeName}){': '}
              {fee.priceModel.formattedPrice}
            </p>
          ))}
        {product.showNavStock &&
        // Render stock statuses from Navision if available and enabled
        navisionStock &&
        navisionStock.stockStatuses ? (
          <>
            {/* Render the first stock status from Navision */}
            {navisionStock.stockStatuses[0] && (
              <StockStatus
                {...navisionStock.stockStatuses[0].stockStatus}
              />
            )}

            {/* Render the second stock status from Navision */}
            {navisionStock?.stockStatuses[1] && (
              <StockStatus
                {...navisionStock.stockStatuses[1].stockStatus}
              />
            )}
            {product.showNavStock &&
              navisionStock?.formattedExpectedArrivalDate && (
                <div className="flex-1 text-xs">
                  {formatIncomingStocksString(
                    navisionStock.totalIncomingQuantity,
                    navisionStock.firstShipmentQuantity,
                    navisionStock.formattedExpectedArrivalDate
                  )}
                </div>
              )}
          </>
        ) : (
          // Render default stock status (Litium stock) if Navision is unreachable or disabled
          <>
            <StockStatus {...product.stockStatus} />
          </>
        )}
      </div>
    </a>
  );
};

export default ProductCardQuickSearch;
